// extracted by mini-css-extract-plugin
module.exports = {"Feature-container":"Features_Feature-container__1Ox_J","Home":"Features_Home__17FDP","Main":"Features_Main__2XZ0B","Feature":"Features_Feature__1GXzT"};